import { render, staticRenderFns } from "./FormPanel.vue?vue&type=template&id=0dab9c4e&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=js"
export * from "./FormPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab9c4e",
  null
  
)

export default component.exports